var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-success"},[_c('h1',{staticClass:"title"},[_vm._v("支付失败")]),_c('img',{staticClass:"image",attrs:{"src":require('@/assets/payFailure.png')}}),_c('p',{staticClass:"message"},[_vm._v("请联系工具相关管理员处理！谢谢！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }